import { useQuery } from 'react-query';
import { isNil } from 'lodash';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import useInjection from 'hooks/useInjection';

export const useContacts = (
  customerId: unknown,
  options?: Record<string, unknown>,
) => {
  const contactService = useInjection(SERVICE_IDENTIFIER.ContactService);

  return useQuery({
    queryKey: ['contacts', customerId],
    queryFn: () => contactService.getContactsNew(customerId),
    enabled: !isNil(customerId),
    placeholderData: [],
    initialData: isNil(customerId) ? [] : undefined,
    ...options,
  });
};

export const useCustomerContacts = (
  customerId: unknown,
  options: Record<string, unknown> = {},
) => {
  const contactService = useInjection(SERVICE_IDENTIFIER.ContactService);

  return useQuery({
    queryKey: ['contacts', customerId],
    queryFn: () => contactService.getCustomerContacts(customerId),
    enabled: !isNil(customerId),
    placeholderData: [],
    initialData: isNil(customerId) ? [] : undefined,
    ...options,
  });
};

export const useContactInfoById = (customerId: unknown, contactId: unknown) =>
  useCustomerContacts(customerId, {
    select: (contacts: { contactId: unknown }[]) =>
      contacts.filter((contact) => contact.contactId === contactId),
  });
